import { api } from "./api";

export const obtenerTodasLasCategorias = async () => {
  const { data } = await api.get("/categorias/all");
  return data;
};
